module.exports = __webpack_public_path__ + "static/media/Slot_Coins@3x.b3acd1af.png";